


























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Order } from '@accounting/interfaces/order';
import {
  AddPaymentErrorObject,
  addPaymentFields,
  AddPaymentInterface,
} from '@accounting/config/addPaymentConfig';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import Time from '@shared/components/forms/inputs/time/time.vue';
import { format } from 'date-fns/esm';
import FormProvider from '@shared/components/forms/form-provider.vue';

@Component({
  name: 'bc-add-payment-modal',
  components: {
    'bpc-form-provider': FormProvider,
    'bpc-input-group': InputGroup,
    'bpc-input': Input,
    'bpc-select': Select,
    'bpc-datepicker': Datepicker,
    'bpc-time': Time,
  },
})
export default class AddPaymentModal extends Vue {
  @Prop({ type: Number, default: null }) readonly productId!: number;
  @Prop({ type: String, default: null }) readonly productType!: string;
  @Prop({ type: Boolean, default: false }) readonly showModal!: boolean;
  @Prop({ type: String, default: 'add-payment-modal' }) readonly modalId!: string;

  isProcessing = false;
  isLoading = true;
  paymentAllowed = true;
  paymentNotAllowedMsg = 'Payment not allowed';
  ordersToPay: Order | null = null;

  formModel: AddPaymentInterface = {
    paid_amount: 0,
    contactFullname: '',
    paymentMethodType: 'money_transfer',
    payment_date: format(new Date(), 'yyyy-MM-dd'),
    payment_time: format(new Date(), 'HH:mm:ss'),
  };

  errorsObject: AddPaymentErrorObject = {};

  get tenantType(): string {
    return this.$store.getters['centerSettings/centerType'];
  }

  get modalTitle(): string {
    return this.$t('accounting.payment.modal.add-payment.title').toString();
  }

  get productPath(): string | null {
    switch (this.productType) {
      case 'entry':
        return 'entry';
      case 'subscription':
        return 'subscription';
      case 'attendee':
        return 'activity-session-attendee';
      case 'booking':
        return 'booking';
      case 'booking-event':
        return 'booking-event';
      case 'enrollment':
        return 'enrollment';
      default:
        return null;
    }
  }

  get fieldsConfig() {
    return addPaymentFields;
  }

  get centerCountry(): string {
    return this.$store.getters['centerSettings/centerSettings'].country;
  }

  get paymentMethodTypeFieldConfig() {
    return this.centerCountry === 'fr'
      ? this.fieldsConfig.paymentMethodTypeFR
      : this.fieldsConfig.paymentMethodType;
  }

  // FIXME use helper (waiting from other branch).
  get label() {
    return {
      labelAttributes: {
        for: 'test',
      },
      labelClass: {
        'mt-1 mb-0': true,
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 pl-2': true,
        },
      },
    };
  }
  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 pl-2': true,
        },
      },
    };
  }

  onChangeErrorObject(field) {
    delete this.errorsObject[field];
  }

  manageSaveErrors(errors: any) {
    this.errorsObject = {};
    Object.keys(errors).forEach(key => {
      const aux = {
        error: errors[key][0],
        state: false,
      };
      this.$set(this.errorsObject, key, aux);
    });
  }

  mounted() {
    if (this.showModal) {
      this.openModal();
      this.getOrdersToPay();
    }
  }

  closeModal() {
    this.$emit('close-modal');
    this.$bvModal.hide(this.modalId);
  }

  openModal() {
    this.$bvModal.show(this.modalId);
  }

  async getOrdersToPay() {
    this.isProcessing = true;

    const productPath = this.productPath;
    if (productPath) {
      const url = `${this.$bpcApiRouteHelper.getEntityPath('payment')}/product/${
        this.productId
      }/product-type/${this.productType}/can-be-paid`;
      try {
        const res = await this.$bpcApi.get(url, {}).toPromise();
        if (res.data.result) {
          this.formModel.paid_amount = res.data.paidAmount;
          this.formModel.contactFullname = res.data.contactFullname;
          this.paymentAllowed = true;
        } else {
          this.paymentAllowed = false;
          this.paymentNotAllowedMsg = res.data.reason
            ? (this.$t(`global.payment.error_message.${res.data.reason}`) as string)
            : 'Payment not allowed';
        }
      } catch (error) {
        this.$bpcMessage.showErrorMessage({ text: 'global.generic.error' });
      }
      this.isLoading = false;
      this.isProcessing = false;
    }
  }

  async addPayment() {
    this.isProcessing = true;

    const productPath = this.productPath;
    if (productPath) {
      const url = `${this.$bpcApiRouteHelper.getEntityPath('payment')}/product/${
        this.productId
      }/product-type/${this.productType}/pay`;
      const params = {
        paid_amount: this.formModel.paid_amount,
        payment_method_type: this.formModel.paymentMethodType,
        payment_date: this.formModel.payment_date,
        payment_time: this.formModel.payment_time,
      };
      try {
        const res = await this.$bpcApi.post(url, params).toPromise();
        if (res.data.result) {
          this.$emit('payment-created');
        } else {
          const errorMsg = res.data.reason
            ? (this.$t(`global.payment.error_message.${res.data.reason}`) as string)
            : 'Payment not allowed';
          this.$bpcMessage.showErrorMessage({ text: errorMsg });
          this.$emit('close-modal');
        }
      } catch (error) {
        if (error?.response?.data?.errors) {
          this.manageSaveErrors(error?.response?.data?.errors);
        }
      }
    } else {
      this.$bpcMessage.showErrorMessage({ text: 'global.generic.error' });
    }
    this.isProcessing = false;
  }
}
